"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_text_mask_1 = __importDefault(require("react-text-mask"));

var Styled_1 = require("./Styled");
/**
 * Input text component
 *
 * @version 1.0.0
 */


var TextInput =
/** @class */
function (_super) {
  __extends(TextInput, _super);

  function TextInput(props) {
    var _this = _super.call(this, props) || this;
    /**
     * onChange function
     * @param {SyntheticEvent} event The react `SyntheticEvent`
     */


    _this.onChange = function (event) {
      var value = event.target.value;

      _this.handleChangeValue(value);
    };

    _this.getValues = function () {
      var _a;

      var id = _this.props.id;
      var value = _this.state.value;

      if (id) {
        return _a = {}, _a[id] = value, _a;
      }

      return {};
    };
    /**
     * handleChangeValue function
     * @param {string} value The next value
     */


    _this.handleChangeValue = function (value) {
      var _a = _this.props,
          id = _a.id,
          onChange = _a.onChange;
      var nextValues = {
        id: id,
        value: value
      };

      if (!_this.isMutableValue && onChange !== undefined) {
        onChange(nextValues);
      } else {
        _this.setState({
          value: value
        }, function () {
          if (onChange !== undefined) {
            onChange(nextValues);
          }
        });
      }
    };
    /**
     * onFocus function
     */


    _this.onFocus = function () {
      _this.setState({
        showClearIcon: true
      });
    };
    /**
     * onBlur function
     */


    _this.onBlur = function () {
      if (!_this.isClearClicked) {
        _this.setState({
          showClearIcon: false
        });
      }
    };
    /**
     * onClearMouseDown function
     */


    _this.onClearMouseDown = function () {
      _this.isClearClicked = true;
    };
    /**
     * clear function
     */


    _this.clear = function () {
      var mask = _this.props.mask;
      _this.isClearClicked = false;

      if (mask) {
        _this.input.current.inputElement.focus();
      } else {
        _this.input.current.focus();
      }

      _this.handleChangeValue('');
    };
    /**
     * renderClearIcon function
     */


    _this.renderClearIcon = function () {
      return react_1.default.createElement(Styled_1.Suffix, {
        onClick: _this.clear,
        onMouseDown: _this.onClearMouseDown
      }, react_1.default.createElement(Styled_1.CancelIcon, null));
    };
    /**
     * renderPrefix function
     */


    _this.renderPrefix = function () {
      var prefix = _this.props.prefix;

      if (!prefix) {
        return null;
      }

      return react_1.default.createElement(Styled_1.Prefix, null, prefix);
    };
    /**
     * renderSuffix function
     */


    _this.renderSuffix = function () {
      var _a = _this.props,
          suffix = _a.suffix,
          allowClear = _a.allowClear;
      var showClearIcon = _this.state.showClearIcon;

      if (allowClear && showClearIcon) {
        return _this.renderClearIcon();
      }

      return suffix ? react_1.default.createElement(Styled_1.Suffix, null, _this.props.suffix) : null;
    };
    /**
     * renderStyledInput function
     */


    _this.renderStyledInput = function (ref, props) {
      var _a = _this.props,
          autoComplete = _a.autoComplete,
          disabled = _a.disabled,
          id = _a.id,
          _b = _a.isDirty,
          isDirty = _b === void 0 ? false : _b,
          placeholder = _a.placeholder,
          prefix = _a.prefix,
          suffix = _a.suffix,
          _c = _a.type,
          type = _c === void 0 ? 'text' : _c,
          required = _a.required,
          tabIndex = _a.tabIndex;
      var optionProps = tabIndex !== undefined ? {
        tabIndex: tabIndex
      } : {};
      return react_1.default.createElement(Styled_1.StyledTextInput, __assign({
        autoComplete: autoComplete,
        ref: ref,
        "data-test-id": _this.testId,
        isDirty: isDirty,
        disabled: disabled,
        id: id,
        name: id,
        placeholder: placeholder,
        required: required,
        type: type,
        hasPrefix: !!prefix,
        hasSuffix: !!suffix
      }, optionProps, props));
    };
    /**
     * renderInput function
     */


    _this.renderInput = function () {
      var _a = _this.props,
          mask = _a.mask,
          placeholder = _a.placeholder;
      var value = _this.props.value !== undefined ? _this.props.value : _this.state.value;

      if (mask) {
        return react_1.default.createElement(react_text_mask_1.default, {
          mask: mask,
          ref: _this.input,
          placeholder: placeholder,
          value: value,
          guide: false,
          render: _this.renderStyledInput,
          onFocus: _this.onFocus,
          onBlur: _this.onBlur,
          onChange: _this.onChange
        });
      }

      return _this.renderStyledInput(_this.input, {
        onChange: _this.onChange,
        onFocus: _this.onFocus,
        onBlur: _this.onBlur,
        value: value
      });
    };

    var defaultValue = props.defaultValue,
        disabled = props.disabled,
        value = props.value,
        testId = props.testId;
    var statValue = value || defaultValue || '';
    _this.state = {
      value: statValue,
      showClearIcon: false
    };
    _this.testId = testId;
    _this.isClearClicked = false;
    _this.isMutableValue = !props.hasOwnProperty('value');
    _this.input = react_1.default.createRef();

    if (!_this.isMutableValue && props.onChange === undefined && !disabled) {
      throw new Error('You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `disabled`');
    }

    return _this;
  }
  /**
   * render function
   */


  TextInput.prototype.render = function () {
    var _a = this.props.tight,
        tight = _a === void 0 ? false : _a;
    return react_1.default.createElement(Styled_1.InputWrapper, {
      className: "input-wrapper",
      tight: tight
    }, this.renderPrefix(), this.renderInput(), this.renderSuffix());
  };

  TextInput.defaultProps = {
    disabled: false,
    isDirty: false,
    mask: false,
    tight: false,
    allowClear: true,
    required: true
  };
  return TextInput;
}(react_1.PureComponent);

exports.TextInput = TextInput;
exports.default = TextInput;